import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'

export type UpdateNpsQuestionCategory = {
  companyId: number
  name?: string
  description?: string
}

export default class NpsQuestionCategoryService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/question-categories'
  }

  async update(id: number, payload: UpdateNpsQuestionCategory) {
    const response = await request.put(`${this.getCompletePath()}/${id}`, payload)
    return response.data
  }
}
